import type { HttpPostMultipart } from '@/shared/infra/http'
import { HttpError, mapServerError } from '@/shared/infra/http'
import { resizeImageForUpload } from '@/shared/infra/files'
import type { UploadProfilePhoto } from '@/modules/auth/use-cases'
import { NetworkError, ProfilePhotoUploadError } from '@/shared/domain'

type UploadResponse = {
  photo: {
    cloudStorageUrl: string
  }
}

export class EdgeUploadProfilePhotoRepository {
  constructor(private readonly http: HttpPostMultipart) {}

  execute: UploadProfilePhoto = async ({ file }) => {
    const form = new FormData()
    form.append('file', await resizeImageForUpload(file))
    try {
      const response = await this.http.postMultipart<UploadResponse>({
        url: '/profile-photos/upload',
        form,
      })
      return { url: response.photo.cloudStorageUrl }
    } catch (err) {
      if (err instanceof HttpError) {
        throw new ProfilePhotoUploadError(extractServerMessage(err.body))
      }
      try {
        mapServerError(err, {})
      } catch {
        throw new NetworkError()
      }
    }
  }
}

function extractServerMessage(body: unknown): string | undefined {
  if (body === null || typeof body !== 'object') return undefined
  const error = (body as { error?: unknown }).error
  return typeof error === 'string' ? error : undefined
}
